import { withChartLayout } from 'components/common';
import SBARReport from 'components/features/chart/special-charts/sbar-report/SBARReport';

const SBARReportPage = withChartLayout('SBAR Report')(SBARReport);
export default SBARReportPage;
